import { type CustomLayerInterface } from 'maplibre-gl';

export class SlotLayer implements CustomLayerInterface {
    constructor(public readonly id: string) {}
    readonly type = 'custom';
    readonly renderingMode?: '2d' | '3d' | undefined;
    render() {}
}
